define(
	'DC.PDPSpecificationTab.PDPSpecificationExt'
,   [
		'DC.PDPSpecificationTab.PDPSpecificationExt.View',
		'ProductDetails.Information.View'
	]
,   function (
		PDPSpecificationExtView,
		ProductDetailsInformationView
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container)
		{
			// using the 'Layout' component we add a new child view inside the 'Header' existing view 
			// (there will be a DOM element with the HTML attribute data-view="Header.Logo")
			// more documentation of the Extensibility API in
			// https://system.netsuite.com/help/helpcenter/en_US/APIs/SuiteCommerce/Extensibility/Frontend/index.html
			
			/** @type {LayoutComponent} */
			var layout = container.getComponent('Layout');
			_.extend(ProductDetailsInformationView.prototype, {
				getContext: function() {
					//
					console.log('details', this.details);
					console.log('model', this.model);
					// 
					// custitem_width
					// custitem_height
					// custitem_depth
					// custitem_weight
					// custitembox_protector_filter
					// custitem_backings_microchamber
					// custitem_cd_poly_sleeves
					// custitem_cd_jewel_cases
					// custitem_comic_book_style_size
					// custitem_record_jacket_sleves_style
					// custitem_record_jacket_sleeve_flap
					// custitem_backings_storage
					// custitem_toploaders_for
					// custitem_shirt_style
					// custitem_record_cleaning_supplies

					// custitem_mailer_style    ==> Mailer Style
					// custitem_storage_length  ==> Storage Length
					// custitem_made_in_usa     ==> Made In USA

                    // custitem_recyclable      ==> Recycle (if it is recyclable, we would put in Yes, <a href="/product-recycling-guide">click here for more info</a>.
                                                 // and if it's not we will just write No)

					var Material = this.model.get('item')?this.model.get('item').get('custitem_material'):'';
					var Thickness = this.model.get('item')?this.model.get('item').get('custitem_sleeve_thickness'):'';
                    var Color = this.model.get('item')?this.model.get('item').get('custitem_color'):'';
                    var Width = this.model.get('item')?this.model.get('item').get('custitem_width'):'';
                    var Height = this.model.get('item')?this.model.get('item').get('custitem_height'):'';
                    var Depth = this.model.get('item')?this.model.get('item').get('custitem_depth'):'';
                    var Weight = this.model.get('item')?this.model.get('item').get('custitem_weight'):'';
                    var BoxProtectorsFilter = this.model.get('item')?this.model.get('item').get('custitembox_protector_filter'):'';
                    var BackingsMicroChamberPaper = this.model.get('item')?this.model.get('item').get('custitem_backings_microchamber'):'';


                    var CDPolySleeves = this.model.get('item')?this.model.get('item').get('custitem_cd_poly_sleeves'):'';
                    var CDJewelCases = this.model.get('item')?this.model.get('item').get('custitem_cd_jewel_cases'):'';
                    var ComicBookPolyBags = this.model.get('item')?this.model.get('item').get('custitem_comic_book_style_size'):'';
                    var RecordJacketSleevesStyle = this.model.get('item')?this.model.get('item').get('custitem_record_jacket_sleves_style'):'';
                    var RecordJacketSleeveFlap = this.model.get('item')?this.model.get('item').get('custitem_record_jacket_sleeve_flap'):'';
                    var BackingsStorage = this.model.get('item')?this.model.get('item').get('custitem_backings_storage'):'';
                    var ToploadersFor = this.model.get('item')?this.model.get('item').get('custitem_toploaders_for'):'';
                    var ShirtStyle = this.model.get('item')?this.model.get('item').get('custitem_shirt_style'):'';
					var RecordCleaningSupplies = this.model.get('item')?this.model.get('item').get('custitem_record_cleaning_supplies'):'';

                    var BlueRayHDDVD = this.model.get('item')?this.model.get('item').get('custitem_blue_ray_hd_dvd'):'';
                    var PHLevel = this.model.get('item')?this.model.get('item').get('custitem_ph_level'):'';
                    var AcidFree = this.model.get('item')?this.model.get('item').get('custitem_acid_free'):'';
                    var LigninFree = this.model.get('item')?this.model.get('item').get('custitem_lignin_free'):'';
                    var Buffered = this.model.get('item')?this.model.get('item').get('custitem_buffered'):'';
                    var PassPAT = this.model.get('item')?this.model.get('item').get('custitem_passed_pat'):'';

                    var mailerStyle = this.model.get('item')?this.model.get('item').get('custitem_mailer_style'):'';
                    var storageLength = this.model.get('item')?this.model.get('item').get('custitem_storage_length'):'';
                    var madeInUSA = this.model.get('item')?this.model.get('item').get('custitem_made_in_usa'):'';   

                    var Recyclable = this.model.get('item')?this.model.get('item').get('custitem_recyclable'):'';                    
                    var SleeveFlap = this.model.get('item')?this.model.get('item').get('custitem_sleeve_flap'):'';
                    var Length = this.model.get('item')?this.model.get('item').get('custitem_length'):'';                   
					
                    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
					var Specifications = {};
					Specifications.name = 'SPECIFICATIONS';

					var IsSpecification = false;				    

					Specifications.content =  '<div class="pdpspecifications">';
					if(Material != '' && Material != null && Material != undefined && Material != '&nbsp;'){
                          var mat = '<p style="font-size: 1.13rem !important;"><strong>Material:  </strong>'+  Material +'</p>'
						  Specifications.content = Specifications.content + mat;
						  IsSpecification = true;
					}
					
					
					if(Thickness != '' && Thickness != null && Thickness != undefined && Thickness != '&nbsp;'){
                          var mat = '<p style="font-size: 1.13rem !important; padding-top: 5px;"><strong>Thickness:  </strong>'+ Thickness +'</p>'
						  Specifications.content = Specifications.content + mat;
						  						  IsSpecification = true;

					}

					if(Color != '' && Color != null && Color != undefined && Color != '&nbsp;'){
                          var mat = '<p style="font-size: 1.13rem !important; padding-top: 5px;"><strong>Color:  </strong>'+ Color +'</p>'
						  Specifications.content = Specifications.content + mat;
						  						  IsSpecification = true;

					}


					if(Width != '' && Width != null && Width != undefined && Width != '&nbsp;'){
                          var mat = '<p style="font-size: 1.13rem !important; padding-top: 5px;"><strong>Width:  </strong>'+ Width +'</p>'
						  Specifications.content = Specifications.content + mat;
						  IsSpecification = true;

					}

					if(Height != '' && Height != null && Height != undefined && Height != '&nbsp;'){
                          var mat = '<p style="font-size: 1.13rem !important; padding-top: 5px;"><strong>Height:  </strong>'+ Height +'</p>'
						  Specifications.content = Specifications.content + mat;
						  IsSpecification = true;

					}


					if(Depth != '' && Depth != null && Depth != undefined && Depth != '&nbsp;'){
                          var mat = '<p style="font-size: 1.13rem !important; padding-top: 5px;"><strong>Depth:  </strong>'+ Depth +'</p>'
						  Specifications.content = Specifications.content + mat;
						  						  IsSpecification = true;

					}

					if(Weight != '' && Weight != null && Weight != undefined && Weight != '&nbsp;'){
                          var mat = '<p style="font-size: 1.13rem !important; padding-top: 5px;"><strong>Weight:  </strong>'+ Weight +'</p>'
						  Specifications.content = Specifications.content + mat;
						  						  IsSpecification = true;

					}


					console.log('Box Protectors Filter', BoxProtectorsFilter);

					if(BoxProtectorsFilter != '' && BoxProtectorsFilter != null && BoxProtectorsFilter != undefined && BoxProtectorsFilter != '&nbsp;'){
						  console.log('Box Protectors Filter', BoxProtectorsFilter);
                          var mat = '<p style="font-size: 1.13rem !important; padding-top: 5px;"><strong>Box Protectors Filter:  </strong>'+ BoxProtectorsFilter +'</p>'
						  Specifications.content = Specifications.content + mat;
						  						  IsSpecification = true;

					}

					if(BackingsMicroChamberPaper != '' && BackingsMicroChamberPaper != null && BackingsMicroChamberPaper != undefined && BackingsMicroChamberPaper != '&nbsp;'){
                          var mat = '<p style="font-size: 1.13rem !important; padding-top: 5px;"><strong>Backings & MicroChamber Paper:  </strong>'+ BackingsMicroChamberPaper +'</p>'
						  Specifications.content = Specifications.content + mat;
						  						  IsSpecification = true;

					}

					if(CDPolySleeves != '' && CDPolySleeves != null && CDPolySleeves != undefined && CDPolySleeves != '&nbsp;'){
                          var mat = '<p style="font-size: 1.13rem !important; padding-top: 5px;"><strong>CD Poly Sleeves:  </strong>'+ CDPolySleeves +'</p>'
						  Specifications.content = Specifications.content + mat;
						  						  IsSpecification = true;

					}

					if(CDJewelCases != '' && CDJewelCases != null && CDJewelCases != undefined && CDJewelCases != '&nbsp;'){
                          var mat = '<p style="font-size: 1.13rem !important; padding-top: 5px;"><strong>CD Jewel Cases:  </strong>'+ CDJewelCases +'</p>'
						  Specifications.content = Specifications.content + mat;
						  						  IsSpecification = true;

					}

					if(ComicBookPolyBags != '' && ComicBookPolyBags != null && ComicBookPolyBags != undefined && ComicBookPolyBags != '&nbsp;'){
                          var mat = '<p style="font-size: 1.13rem !important; padding-top: 5px;"><strong>Comic Book Poly Bags:  </strong>'+ ComicBookPolyBags +'</p>'
						  Specifications.content = Specifications.content + mat;
						  						  IsSpecification = true;

					}
					
					if(RecordJacketSleevesStyle != '' && RecordJacketSleevesStyle != null && RecordJacketSleevesStyle != undefined && RecordJacketSleevesStyle != '&nbsp;'){
                          var mat = '<p style="font-size: 1.13rem !important; padding-top: 5px;"><strong>Record Jacket Sleeves Style:  </strong>'+ RecordJacketSleevesStyle +'</p>'
						  Specifications.content = Specifications.content + mat;
						  						  IsSpecification = true;

					}

					if(RecordJacketSleeveFlap != '' && RecordJacketSleeveFlap != null && RecordJacketSleeveFlap != undefined && RecordJacketSleeveFlap != '&nbsp;'){
                          var mat = '<p style="font-size: 1.13rem !important; padding-top: 5px;"><strong>Record Jacket Sleeve Flap:  </strong>'+ RecordJacketSleeveFlap +'</p>'
						  Specifications.content = Specifications.content + mat;
						  						  IsSpecification = true;

					}

					if(BackingsStorage != '' && BackingsStorage != null && BackingsStorage != undefined && BackingsStorage != '&nbsp;'){
                          var mat = '<p style="font-size: 1.13rem !important; padding-top: 5px;"><strong>Backings Storage:  </strong>'+ BackingsStorage +'</p>'
						  Specifications.content = Specifications.content + mat;
						  						  IsSpecification = true;

					}

					if(ToploadersFor != '' && ToploadersFor != null && ToploadersFor != undefined && ToploadersFor != '&nbsp;'){
                          var mat = '<p style="font-size: 1.13rem !important; padding-top: 5px;"><strong>Toploaders For:  </strong>'+ ToploadersFor +'</p>'
						  Specifications.content = Specifications.content + mat;
						  						  IsSpecification = true;

					}

					if(ShirtStyle != '' && ShirtStyle != null && ShirtStyle != undefined && ShirtStyle != '&nbsp;'){
                          var mat = '<p style="font-size: 1.13rem !important; padding-top: 5px;"><strong>Shirt Style:  </strong>'+ ShirtStyle +'</p>'
						  Specifications.content = Specifications.content + mat;
						  						  IsSpecification = true;

					}

					if(RecordCleaningSupplies != '' && RecordCleaningSupplies != null && RecordCleaningSupplies != undefined && RecordCleaningSupplies != '&nbsp;'){
                          var mat = '<p style="font-size: 1.13rem !important; padding-top: 5px;"><strong>Record Cleaning Supplies:  </strong>'+ RecordCleaningSupplies +'</p>'
						  Specifications.content = Specifications.content + mat;
						IsSpecification = true;

					}

                    if(BlueRayHDDVD != '' && BlueRayHDDVD != null && BlueRayHDDVD != undefined && BlueRayHDDVD != '&nbsp;'){
                          var blueRay = '<p style="font-size: 1.13rem !important; padding-top: 5px;"><strong>Blu-ray/HD DVD:  </strong>'+ BlueRayHDDVD +'</p>'
						  Specifications.content = Specifications.content + blueRay;
						IsSpecification = true;

					}

                    if(PHLevel != '' && PHLevel != null && PHLevel != undefined && PHLevel != '&nbsp;'){
                          var phLevel = '<p style="font-size: 1.13rem !important; padding-top: 5px;"><strong>PH Level:  </strong>'+ PHLevel +'</p>'
						  Specifications.content = Specifications.content + phLevel;
						IsSpecification = true;

					}

                    if(AcidFree != '' && AcidFree != null && AcidFree != undefined && AcidFree != '&nbsp;'){
                          var acidFree = '<p style="font-size: 1.13rem !important; padding-top: 5px;"><strong>Acid-Free:  </strong>'+ AcidFree +'</p>'
						  Specifications.content = Specifications.content + acidFree;
						IsSpecification = true;

					}

                     if(LigninFree != '' && LigninFree != null && LigninFree != undefined && LigninFree != '&nbsp;'){
                          var ligninFree = '<p style="font-size: 1.13rem !important; padding-top: 5px;"><strong>Lignin-Free:  </strong>'+ LigninFree +'</p>'
						  Specifications.content = Specifications.content + ligninFree;
						IsSpecification = true;

					}

                    if(Buffered != '' && Buffered != null && Buffered != undefined && Buffered != '&nbsp;'){
                          var buffered = '<p style="font-size: 1.13rem !important; padding-top: 5px;"><strong>Buffered:  </strong>'+ Buffered +'</p>'
						  Specifications.content = Specifications.content + buffered;
						IsSpecification = true;

					}

                    if(PassPAT != '' && PassPAT != null && PassPAT != undefined && PassPAT != '&nbsp;'){
                          var passPAT = '<p style="font-size: 1.13rem !important; padding-top: 5px;"><strong>Passed P.A.T.:  </strong>'+ PassPAT +'</p>'
						  Specifications.content = Specifications.content + passPAT;
						IsSpecification = true;

					}
					if(mailerStyle != '' && mailerStyle != null && mailerStyle != undefined && mailerStyle != '&nbsp;'){
						  var mailer = '<p style="font-size: 1.13rem !important; padding-top: 5px;"><strong>Mailer Style:  </strong>'+ mailerStyle +'</p>'
						  Specifications.content = Specifications.content + mailer;
						IsSpecification = true;
					}

					if(storageLength != '' && storageLength != null && storageLength != undefined && storageLength != '&nbsp;'){
						  var storage = '<p style="font-size: 1.13rem !important; padding-top: 5px;"><strong>Storage Length:  </strong>'+ storageLength +'</p>'
						  Specifications.content = Specifications.content + storage;
						IsSpecification = true;
					}
					if(madeInUSA != '' && madeInUSA != null && madeInUSA != undefined && madeInUSA != '&nbsp;'){
						  var madeUSA = '<p style="font-size: 1.13rem !important; padding-top: 5px;"><strong>Made In USA:  </strong>'+ madeInUSA +'</p>'
						  Specifications.content = Specifications.content + madeUSA;
						IsSpecification = true;
					}

                    if(Recyclable != '' && Recyclable != null && Recyclable != undefined && Recyclable != '&nbsp;'){
                         var strippedRecyclable = Recyclable.replace(/<[^>]*>/g, '').trim().toLowerCase();
                         var recyclableValue = '';
                         if(strippedRecyclable === 'yes' || strippedRecyclable === 't'){
                            recyclableValue = 'Yes, <a href="/product-recycling-guide">click here for more info</a>';
                        } else {
                            recyclableValue = 'No';
                        }
                       var recycle = '<p style="font-size: 1.13rem !important; padding-top: 5px;"><strong>Recyclable:  </strong>'+ recyclableValue +'</p>'
                       Specifications.content = Specifications.content + recycle;
                       IsSpecification = true;
                    }

                   if(SleeveFlap != '' && SleeveFlap != null && SleeveFlap != undefined && SleeveFlap != '&nbsp;'){
                       var sleeveFlapVal = '<p style="font-size: 1.13rem !important; padding-top: 5px;"><strong>Sleeve Flap:  </strong>'+ SleeveFlap +'</p>'
                       Specifications.content = Specifications.content + sleeveFlapVal;
                       IsSpecification = true;
                  }

                  if(Length != '' && Length != null && Length != undefined && Length != '&nbsp;'){
                          var lengthValue = '<p style="font-size: 1.13rem !important; padding-top: 5px;"><strong>Length:  </strong>'+ Length +'</p>'
						  Specifications.content = Specifications.content + lengthValue;
						  IsSpecification = true;

					}
                    
                  
					Specifications.content = Specifications.content + '</div>';
					Specifications.itemprop = 'specifications';


					if(IsSpecification){
					  this.details.push(Specifications);
					}


					return {
						// @property {Boolean} showInformation
						showInformation: this.details.length > 0,
						// @property {Boolean} showHeader
						showHeader: this.details.length < 2,
						// @property {Array<ProductDetails.Information.DataContainer>} details
						details: this.details,
						// @property {Boolean} isNotPageGenerator
						isNotPageGenerator: !SC.isPageGenerator()
					};
				}
			})
			

		}
	};
});
